module.exports = __webpack_public_path__ + "media/images/not_found-c5b82722f5b3c3b0d1cb6bba3953e25b.svg";